import { cn } from "@/lib/utils";

interface SeparatorProps {
  /** Direction. Default: horizontal */
  orientation?: "horizontal" | "vertical";
  /** Optional label centered in the separator */
  label?: string;
  className?: string;
}

/**
 * Visual separator between content sections.
 * Optionally displays a centered label (like "or", a date, etc.)
 */
export function Separator({
  orientation = "horizontal",
  label,
  className,
}: SeparatorProps) {
  if (orientation === "vertical") {
    return (
      <div
        className={cn("w-px self-stretch bg-intri-border", className)}
        role="separator"
        aria-orientation="vertical"
      />
    );
  }

  if (label) {
    return (
      <div
        className={cn("flex items-center gap-3", className)}
        role="separator"
      >
        <div className="flex-1 h-px bg-intri-border" />
        <span className="text-2xs text-intri-muted shrink-0">{label}</span>
        <div className="flex-1 h-px bg-intri-border" />
      </div>
    );
  }

  return (
    <div
      className={cn("h-px w-full bg-intri-border", className)}
      role="separator"
      aria-orientation="horizontal"
    />
  );
}
